import { ColorType } from "lightweight-charts";
import type { RefObject } from "react";
import {
	BACKGROUND_COLOR,
	TEXT_COLOR,
} from "@/components/widgets/Revision/config";

export const getChartOptions = (
	chartContainerRef: RefObject<HTMLDivElement | null>,
	twoPriceScales = false,
) => {
	const width = chartContainerRef.current?.clientWidth || 300;
	const height = chartContainerRef.current?.clientHeight || 200;

	return {
		layout: {
			background: {
				type: ColorType.Solid,
				color: BACKGROUND_COLOR,
				textColor: TEXT_COLOR,
			},
			textColor: TEXT_COLOR,
		},
		grid: {
			vertLines: { color: BACKGROUND_COLOR },
			horzLines: { color: BACKGROUND_COLOR },
		},
		width,
		height,
		...(twoPriceScales
			? {
					rightPriceScale: { visible: true },
					leftPriceScale: { visible: true },
				}
			: {}),
	};
};
